module.exports = __webpack_public_path__ + "roboto-black-webfont.80ed3c0a3bfed25f2504.svg";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/assets/fonts/roboto-black-webfont.svg
// module id = ../../../../../src/assets/fonts/roboto-black-webfont.svg
// module chunks = styles